export class CategoryProduct {
    Id_CategoryProduct: number;
    CategoryName: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/category-product-model.ts